import { Trans } from 'react-i18next';

const DATE_RANGE = [
  {
    label: <Trans i18nKey="sinceActivated" />
  },
  {
    label: <Trans i18nKey="weekToDate" />,
    value: 'week'
  },
  {
    label: <Trans i18nKey="monthToDate" />,
    value: 'month'
  },
  {
    label: <Trans i18nKey="yearToDate" />,
    value: 'year'
  },
  {
    label: <Trans i18nKey="lastSevenDays" />,
    value: 7
  },
  {
    label: <Trans i18nKey="lastThirtyDays" />,
    value: 30
  },
  {
    label: <Trans i18nKey="lastNinetyDays" />,
    value: 90
  }
];

export { DATE_RANGE };
